import './index.scss';

import * as React from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import {BandLayout} from '../../../components';
import {Context} from '../../../context/dataStore';
import MajorSearch from './MajorSearch/MajorSearch';
import MajorSelected from './MajorSelected';
import ActiveAccordion from './ActiveAccordion';
import RenderButton from './RenderButton/RenderButton';
//import RenderNav from './RenderNav/RenderNav';
import {triggerModal, closeModal} from '../../../utils/utils';
import {formatSavePayload} from './util';
import {getModuleStatusStr, alertShow} from '../../../utils/utils';
import TotalUtils from '../../../utils/TotalUtil';
import SuccessMessageModal from '../ModulePage/Modals/SuccessMessageModal';
import ErrorMessageModal from '../ModulePage/Modals/ErrorMessageModal';
import SubmitModalConfirmation from '../../../components/Modals/submitConfirmation';
import UnsubmitConfirmation from '../../../components/Modals/unsubmitConfirmation';
import BasicErrorModal from '../../../components/Modals/errorModal';
import SubmitModal from '../../../components/Modals/submitModal';
import ForgotToSaveModal from '../../../components/Modals/forgotToSaveModal';
import ModalComponent from '../../../components/Modals';
import {saveSuccessMsg, saveErrorMsg} from '../../../constants/messages';
import {SUBMITTED_FOR_REVIEW, PUBLISHED} from '../../../constants/status';
import {ADMIN_ROLE} from '../../../constants/global'

const DegreeOfferredPerMajors =({CategoryName, org_id, cat_id, status, org_rol_s, categTooltip})=> {
  const TUtil = new TotalUtils();
  // getting data from context
  const {state: {metaDataAboutUser}, postModule, submitModule, unsubmitModule, dispatch} = React.useContext(Context);
  // This may map to accordionData later--Jim
  const [searchResult, setSearchResult] = React.useState([]);

  /**
   * "middlearray" is like a middleware honestly. It is passed down into accordion.
   * middlearray is then passed to majorselected component where pagination and search has access to modify it as well. The resulting array is passed into major selected table.
   */
  const [middlearray, setMiddleArray] = React.useState([]);
  const [selectarray, setSelectedArray] = React.useState([]);
  //accordion data
  const [accordionData, setAccordionData] = React.useState([]);
  //used to decide if all majors have been added
  const [addAllToListFlag, updateAllToListFlag] = React.useState(false);
  const [isDisabled, setIsDisable] = React.useState(true);
  //modifiedOn
  const [modifiedOn, setModifiedOn] = React.useState('Unmodified');
  const [intendedPath, setPath] = React.useState('#');

  let navigate = useNavigate();

  // metadata passed from card components

  const [readOnly, setReadOnly] = React.useState((org_rol_s !== ADMIN_ROLE && (status.toUpperCase() === SUBMITTED_FOR_REVIEW||status.toUpperCase() === PUBLISHED)) || (org_rol_s == ADMIN_ROLE && status.toUpperCase() === PUBLISHED));

  //for submission errors
  const [tableData, setTableData] = React.useState([]);
  //reuse messages
  const [alertMessage, setAlertMessage] = React.useState({id:-1, message:''});
  //for save
  const [isSaving, setIsSaving] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  //search keyword
  const [searchKeyword, setSearchKeyWord] = React.useState('');

  React.useEffect(() => {
    if(searchResult && searchResult.data) {
      setAccordionData(() => [...searchResult.data]);
    }
  }, [searchResult]);

  //this is used to handle back button on browser
  // React.useLayoutEffect(() => {
  //   window.history.pushState('', null, './');
  //   window.onpopstate = event => {
  //     event.preventDefault();
  //     document.getElementById('categoryclick_degreeofferred').click();
  //   };
  // }, []);

  React.useLayoutEffect(() => {
    let isCurrent = true;
    if(isCurrent){
      window.scrollTo(0, 0);
    }
    return() => isCurrent=false;
  }, []);

  // const redirectional = () => {
  //   closeModal('confirmdialog');
  //   dispatch({type:'SEL_SEARCH_VAL',payload:''});
  //   window.location.replace(`${intendedPath}`);
  // };

  //submit
  const submitAction = async() => {
    const putdata = [{
      id: parseInt(cat_id),
      status: SUBMITTED_FOR_REVIEW
    }];
    try {

      let timeElapsed = Date.now();
      let today = new Date(timeElapsed);
      //console.log(`before:`+today.toISOString());

      const res = await submitModule(putdata, org_id);

      timeElapsed = Date.now();
      today = new Date(timeElapsed);
      if (res.data.status === 'Error' || res.data.statusCode !== 200 || (res.status !== 200 && res.data === null)) {
        setTableData(res?.data.data);
        triggerModal('submitfailedtrigger');
      } else {
        //submitted
        navigate(`/organizations/${org_id}/categories/1/${org_rol_s}`);
      }
    } catch (error) {
      setAlertMessage({id: 'errorMessageModal', message: 'server error'});
      triggerModal('errorMessageModal');
    }
  };

  const onSubmit = async () => {
    //if page is dirty
    if(TUtil.anyUnsavedInMap(selectarray)) {
      triggerModal('forgottosavemodal');
    } else {
      triggerModal('confirmsubmitconfirmation');
    }
  };

   // Runs the unsubmit API then verifies
   const unsubmitAction = async() => {
    try {
      const res = await unsubmitModule(org_id, cat_id);
      if (res.data.status === 'Error' || res.data.statusCode !== 200 || (res.status !== 200 && res.data === null)) {
        triggerModal('unsubmiterror');
      } else {
        //navigate to page with unsubmit banner 
        navigate(`/organizations/${org_id}/categories/2/${org_rol_s}`);
      }
    } catch (error) {
      setAlertMessage({id: 'errorMessageModal', message: 'server error'});
      triggerModal('errorMessageModal');
    } 
  };
  //Basic "forgot to  save" step
  const unSubmit = async () => {
    if(TUtil.anyUnsavedInMap(selectarray)) {
      //this modal has updated language and logic
      triggerModal('forgottosavemodalunsubmitversion');
    } else {
      triggerModal('confirmunsubmitconfirmation');
    }
  };

  const confirmWorkIsSave = pathToGo => {
    //page is dirty
    if(TUtil.anyUnsavedInMap(selectarray)) {
      setPath(pathToGo);
      triggerModal('confirmdialog');
    } else{
      //page not dirty
      setPath(pathToGo);
      window.location.replace(`${pathToGo}`);
    }
  };

  const onSave = async () => {
    //prepare payload by looping through totalMap
    const apiArr = [];
    //el : text, qid, degrees[],new, modified
    selectarray.forEach(major => {
      if(major.new===true && major.boxChecked!== false) {
        //record is new and not removed
        const mypayload = formatSavePayload(major.qid, major.degrees, major.boxChecked);
        apiArr.push(mypayload);
      }
      if(major.new !==true && major.modified===true) {
        //record is old, if it is modified
        const mypayload = formatSavePayload(major.qid, major.degrees, major.boxChecked);
        apiArr.push(mypayload);
      }
    });
    if(apiArr.length>0) {
      //call api, get last updated time.
      const result = await postModule(apiArr, org_id);
      //error case 1:
      //const result={status:300}
      //error case 2:
      //const result={status:200, data:{status:'error'}}
      const {status, data} = result;

      if (status !== 200) { //could be system error
        setAlertMessage({id: 'errorMessageModal', message: 'system error'});
        alertShow('error', 'errorMessageModal');
      } else {
        if (data.status !== 'SUCCESS') {
          setAlertMessage({id: 'errorMessageModal', message: saveErrorMsg});
          alertShow('error', 'errorMessageModal');
        } else{
          if(data.data[0]) { //real saved
            //reset all new: true to be false, modifed to be false
            selectarray.forEach(major => {
              major.modified = false;
              major.new = false;
            });
            setModifiedOn(getModuleStatusStr('Modified', `${data.data[0].module_last_updated_at}`));
            alertShow('successMessageModal');
          }
        }
      }
    }
  };

  return(
    <div className='container-degreeofferred'>
      <SubmitModal modalId='submitfailedtrigger' modalData={tableData} />
      <SubmitModalConfirmation submitAction={() => submitAction()} modalId='confirmsubmitconfirmation' />
      <UnsubmitConfirmation unsubmitAction={()=> unsubmitAction()} modalId='confirmunsubmitconfirmation' />
      <ForgotToSaveModal submitAction={() => submitAction()} modalId='forgottosavemodal' bodycontent={[]} />
      <ForgotToSaveModal submitAction={() => unsubmitAction()} modalId='forgottosavemodalunsubmitversion' bodycontent={[]} title={"Your unsaved changes will not be saved."} label={"Unsubmit"} />
      <ErrorMessageModal message={alertMessage.message} />
      <SuccessMessageModal message={saveSuccessMsg} />
      <BasicErrorModal modalId='unsubmiterror' unsubmitAction={unSubmit}/>
      <ModalComponent modalId='confirmdialog' redirectional={() => redirectional()} bodycontent={[]} />


      <div className='container2' style={{paddingLeft:'10px'}}>
        {/* SEARCH BAR TO FILTER SELECTED MAJORS */}
        <div className='row'>
          <span role='heading' aria-level='2' id='degreeofferingsselectedmajor' style={{width:'80%'}}>Degree Offerings for Majors</span>
          <span aria-level='2' id='lastmodified'>{modifiedOn} </span>
        </div>
        <div className='row'>
          <span style={{marginRight:'40px'}} >
            We prepopulated this section with the Classification of Instructional Programs (CIP) data that you provided in previous Common Data Set (CDS) or Annual Survey of Colleges (ASC) cycles. Please make sure to update the section with any new major/programs of study or new degree types.
            <br /><br />
            You can use the Search section below the table to add new or missing majors. Don’t forget to include the degree types for all majors.
          </span>
        </div>

        {/* TABLE FOR SELECTED MAJORS */}
        <div className='row'>
          <MajorSelected setSelectedArray={setSelectedArray} selectarray={selectarray} readOnly={readOnly} stateProps={{CategoryName, org_id, cat_id, status, org_rol_s, categTooltip, setModifiedOn}} />
        </div>
        {/* MAJORS */}
        <hr className='horizontalLine' />
        <div className='row'>
          <span role='heading' aria-level='2' className='col-sm-12' id='container-degreeofferred_h2'>
            Search for New Majors to Add to Your List
          </span >
          <span role='heading' aria-level='3' className='col-sm-12' id='container-degreeofferred_h3'>
            Use this search tool to add new majors to your list. Then indicate what degree levels your institution offers for each major in the first table and save your selections.
          </span >
        </div>
        <div className='row' id='majorDesc'>
          <label htmlFor='majorSearchInput'>
            <span className='col-sm-12'>
              Please indicate which degree(s) your institution currently offers for each major. If majors are missing from the table, use the search section below to add additional majors. These degree offerings conform to the Classification of Instructional Programs (CIP) 2020. Please search for an add majors and areas of study at your institution by entering CIP codes or keywords. Please do not select more than one name for each major, and do not select a checkbox if only a course or concentration is offered in that subject. You will not be able to enter majors that do not have a designated CIP code at this time.
            </span>
          </label>
        </div>
        <div className='row col-sm-12'>
          <MajorSearch setSearchKeyWord={setSearchKeyWord} setAccordionData={setAccordionData} setSearchResult={setSearchResult} setIsDisable={setIsDisable} updateAllToListFlag={updateAllToListFlag} org_id={org_id} readOnly={readOnly} />
        </div>

        {/* SEARCH RESULTS */}
        <div className='row' style={{width: '82vw', height: '60%', overflow: 'scroll'}}>
          <span role='heading' aria-level='3' id='searchresultsheader' className='col-sm-5'>Search Results</span>
          <span className='col-sm-7 searchresultflex'>
            <span role='status' className='searchresultflex_items' style={accordionData.length===0? {color: '#757575'}: {color: '#1D7846'}}>({TUtil.onlyTrueObjects(selectarray).length}) Majors Added to List
            </span>
            <span className='vertLine searchresultflex_items' />
            <span className='searchresultflex_items'>
              <button type='button' className='cb-btn cb-btn-naked addAllMajorBtn' style={{color: '#324DC7', padding: '0px'}} 
                      disabled={readOnly}
                      aria-readonly={readOnly}
                      onClick={() => {
                        TUtil.addAllResult(middlearray, selectarray, setSelectedArray);
                        dispatch({type: 'SELECT_ALL_COLUMNS', payload: [false, false, false, false, false, false, false, false, false]});
                        updateAllToListFlag(true);
              }} >Add all Results</button>
            </span>
          </span>
        </div>
        <hr className='horizontalLine' style={accordionData.length>0?{display: 'none'}:{display: 'inherit'}} />
        {/* ACCORDION FOR SEARCH RESULTS */}
        <div className='row' style={{width: '82vw'}}>
          <div className='col-sm-12'>
            {
              accordionData.length === 0?
                <p style={{width: '70vw', textAlign: 'center'}}>No Search Results</p>
                :
                <ActiveAccordion middlearray={middlearray} setMiddleArray={setMiddleArray} setSelectedArray={setSelectedArray} selectarray={selectarray} updateAllToListFlag={updateAllToListFlag} data={accordionData} />
            }
          </div>
        </div>
      </div>


      <div className='container-navigation cb-sticky cb-sticky-active cb-sticky-bottom' style={{"backgroundColor":"#324dc7",'height':'80px'}}>
        {/* <RenderNav CategoryName={CategoryName} org_id={org_id} cat_id={cat_id} status={status} org_rol_s={org_rol_s} confirmAction={confirmWorkIsSave} /> */}
        <RenderButton isSaving={isSaving} isSubmitting={isSubmitting} saveAction={onSave} submitAction={onSubmit} unsubmitAction={unSubmit} readOnly={readOnly}/>
      </div>
    </div>
  );
}

export default DegreeOfferredPerMajors;
